module.exports = __webpack_public_path__ + "static/media/feature-demo-2.b6ae7c5e.jpg";